import { render, staticRenderFns } from "./commodityHl.vue?vue&type=template&id=13254a36&scoped=true&"
import script from "./commodityHl.vue?vue&type=script&lang=js&"
export * from "./commodityHl.vue?vue&type=script&lang=js&"
import style0 from "./commodityHl.vue?vue&type=style&index=0&id=13254a36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13254a36",
  null
  
)

export default component.exports